module.exports = __webpack_public_path__ + "static/media/icon_sort_up.465315e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_sort_up.png
// module id = 457
// module chunks = 0